<template>
  <div>
    <!-- 工具栏 -->
    <div class='navbar'>
      <el-button type='primary' icon='sys sys-refresh' class='navbarbtn'
        @click='deepRefreshMainTableContent'>
        刷 新
      </el-button>

      <el-button type='primary' icon='sys sys-sync' class='navbarbtn'
        @click='synchronization'>
        同 步
      </el-button>

      <el-button type='primary' icon='sys sys-set' class='navbarbtn' v-if='showSetPower'
        @click='showSetDialogMD(false)'>
        设 置
      </el-button>

      <el-button type='warning' icon='sys sys-set' class='navbarbtn' v-if='showSetPower'
        @click='showSetDialogMD(true)'>
        批量设置
      </el-button>

      <el-button type='primary' icon='sys sys-edit' class='navbarbtn' v-if='showSetCustomNo'
        @click='showEditCustomNoDialogMD'>
        变更客户料号
      </el-button>

      <!-- <el-button type='primary' icon='sys sys-expand' class='navbarbtn'
        @click='mainTableExpandRow'>
        展 开
      </el-button>

      <el-button type='primary' icon='sys sys-narrow' class='navbarbtn'
        @click='mainTableNarrowRow'>
        收 起
      </el-button> -->

      <TableColumnSet :columnSetLoading='mainTable.ColumnSetLoading'
        :showColumnSetDialog='mainTable.showColumnSetDialog'
        :changeShowColumnSetDialog='mainTable.changeShowColumnSetDialog'
        :columnInfo='mainTable.userColumnInfo'
        :tableInfo='mainTable.userTableInfo'
        @updateUserColumnSetDialogReset='mainTableUpdateUserColumnSetDialogReset'
        @saveUserTableColumn='mainTableSaveUserTableColumn'
        @returnDefaultTableColumn='mainTableReturnDefaultTableColumn'
        @showColumnSetDialogMD='mainTableShowColumnSetDialogMD'>
      </TableColumnSet>

      <TableFilterSet :filterSetLoading='mainTable.FilterSetLoading'
        :showFilterSetDialog='mainTable.showFilterSetDialog'
        :changeShowFilterSetDialog='mainTable.changeShowFilterSetDialog'
        :filterInfo='mainTable.userFilterInfo'
        :columnInfo='mainTable.columnInfo'
        @updateUserFilterDialogReset='mainTableUpdateUserFilterDialogReset'
        @saveUserTableFilter='mainTableSaveUserTableFilter'
        @returnDefaultTableFilter='mainTableReturnDefaultTableFilter'
        @showFilterSetDialogMD='mainTableShowFilterSetDialogMD'>
      </TableFilterSet>

      <TableFilter :filterLoading='mainTable.FilterLoading'
        :showFilterDialog='mainTable.showFilterDialog'
        :changeShowFilterDialog='mainTable.changeShowFilterDialog'
        :filterInfo='mainTable.filterInfo'
        :columnInfo='mainTable.columnInfo'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        @showFilterDialogMD='mainTableShowFilterDialogMD'
        @filter='mainTableFilter'>
      </TableFilter>

      <TableFilterOutDisplay v-for='oneFilterInfo in mainTable.filterInfo'
        :key='oneFilterInfo.ColumnCode + oneFilterInfo.FilterType'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        :columnInfo='mainTable.columnInfo'
        :oneFilterInfo='oneFilterInfo' @filter='mainTableFilter'>
      </TableFilterOutDisplay>
    </div>

    <!-- 行展开收起    :expandRowKeys='mainTable.expandRowKeys' -->
    <Table :data='mainTable.tableContent' :tableInfo='mainTable.tableInfo'
      :columnInfo='mainTable.columnInfo' :disPlayColumnInfo='mainTable.disPlayColumnInfo'
      :page-size='mainTable.pageSize' :page='mainTable.page'
      :total='mainTable.total' v-loading='mainTable.Loading'
      :row-style='mainTableRowStyle'
      :showOperationsColumn='false'
      :showDefaultExpandColumn='true' :showExpandColumn='false'
      :getSpecialStringArray='mainTableGetSpecialStringArray'
      @selection-change='mainTableSelectionChange'
      @page-change='mainTablePageChange' @size-change='mainTableSizeChange'
      @sort-change='mainTableSortChange'>
    </Table>

    <el-dialog v-dialogDrag title='设置' :visible.sync='showSetDialog' width='370px'
      top='10px' lock-scroll>
      <div style='margin-top: -30px;'>
        <div style='margin-top: 0px;'>
          <div class='inputField-label' style='width: 160px; text-align: left'>
            是否可入库
          </div>
          <Select selectStyle='width: 150px; margin-right: 10px;' size='mini' v-model='canInStock'
            :outSelectDatas='yesornos' placeholder='' :clearable='true'></Select>
        </div>
        <div style='margin-top: 10px;'>
          <div class='inputField-label' style='width: 160px; text-align: left'>
            最大生产至入库天数
          </div>
          <el-input v-model='maxInStockDays'
            size='mini' style='width: 150px;'>
          </el-input>
        </div>
        <div style='margin-top: 10px;'>
          <div class='inputField-label' style='width: 160px; text-align: left'>
            是否先进先出
          </div>
          <Select selectStyle='width: 150px; margin-right: 10px;' size='mini' v-model='fifo'
            :outSelectDatas='yesornos' placeholder='' :clearable='true'></Select>
        </div>
        <div style='margin-top: 10px;'>
          <div class='inputField-label' style='width: 160px; text-align: left'>
            产品保质期计算方式
          </div>
          <Select selectStyle='width: 150px; margin-right: 10px;' size='mini' v-model='icmoPeriodComputeType'
            :outSelectDatas='icmoPeriodComputeTypes' placeholder='' :clearable='true'></Select>
          </div>
        <div style='margin-top: 10px;'>
          <div class='inputField-label' style='width: 160px; text-align: left'>
            产品批号计算方式
          </div>
          <Select selectStyle='width: 150px; margin-right: 10px;' size='mini' v-model='icmoBatchNoComputeType'
            :outSelectDatas='icmoBatchNoComputeTypes' placeholder='' :clearable='true'></Select>
          </div>
        <div style='margin-top: 10px;'>
          <div class='inputField-label' style='width: 160px; text-align: left'>
            领料申请精度
          </div>
          <el-input v-model='precision'
            size='mini' style='width: 150px;'>
          </el-input>
        </div>
        <div style='margin-top: 10px;'>
          <div class='inputField-label' style='width: 160px; text-align: left'>
            保质期预警期
          </div>
          <el-input v-model='warningKFPeriod'
            size='mini' style='width: 150px;'>
          </el-input>
        </div>
        <div style='margin-top: 10px;' v-if='batchSetFlag'>
          <div class='inputField-label' style='width: 160px; text-align: left; color: blue'>
            物料代码开头
          </div>
          <el-input v-model='filterItemNumber'
            size='mini' style='width: 150px;'>
          </el-input>
        </div>
        <div class='dialogButtomCenterBtn' style='margin-top: 10px;'>
          <el-button type='primary' @click='setItemSet()' size='mini'>设置</el-button>
          <el-button @click='showSetDialog = false' size='mini'>取消</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog v-dialogDrag title='变更客户料号' :visible.sync='showEditCustomNoDialog' width='280px'
      top='10px' lock-scroll>
      <div style='margin-top: -30px;'>
        <div style='margin-top: 0px;'>
          <div class='inputField-label' style='width: 80px; text-align: left'>
            客户料号
          </div>
          <el-input v-model='customNo'
            size='mini' style='width: 150px;'>
          </el-input>
        </div>
        <div class='dialogButtomCenterBtn' style='margin-top: 10px;'>
          <el-button type='primary' @click='editCustomNo()' size='mini'>保存</el-button>
          <el-button @click='showEditCustomNoDialog = false' size='mini'>取消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import table from '@/components/sys/Table'
import Table from '@/components/sys/Table.vue'
import tableColumnSet from '@/components/sys/TableColumnSet'
import TableColumnSet from '@/components/sys/TableColumnSet.vue'
import tableFilterSet from '@/components/sys/TableFilterSet'
import TableFilterSet from '@/components/sys/TableFilterSet.vue'
import tableFilter from '@/components/sys/TableFilter'
import TableFilter from '@/components/sys/TableFilter.vue'
import TableFilterOutDisplay from '@/components/sys/TableFilterOutDisplay.vue'
import code from '@/components/sys/Code'
import Select from '@/components/sys/Select.vue'
import axiosHelper from '@/utils/axiosHelper'
import { Loading } from 'element-ui'
import power from '@/components/sys/Power'

export default {
  name: 'Item',
  components: {
    Table: Table,
    TableColumnSet: TableColumnSet,
    TableFilterSet: TableFilterSet,
    TableFilter: TableFilter,
    TableFilterOutDisplay: TableFilterOutDisplay,
    Select
  },
  metaInfo: function () {
    return {
      title: this.menuName
    }
  },
  data: function () {
    return {
      menuCode: '',
      menuName: '',
      mainTable: {
        tableCode: 'BD_Item',
        tableInfo: {},
        columnInfo: [],
        disPlayColumnInfo: [],
        tableContent: [],
        pageSize: 50,
        page: 1,
        total: 0,
        defaultOrderStr: '',
        orderStr: '',
        defaultFilterStr: '',
        filterStr: '',
        Loading: false,

        userColumnInfo: [],
        userTableInfo: {},
        showColumnSetDialog: false,
        changeShowColumnSetDialog: false,
        ColumnSetLoading: false,

        userFilterInfo: [],
        showFilterSetDialog: false,
        changeShowFilterSetDialog: false,
        FilterSetLoading: false,

        filterInfo: [],
        showFilterDialog: false,
        changeShowFilterDialog: false,
        FilterLoading: false,

        selections: [],
        expandRowKeys: []
      },

      showSetDialog: false,
      canInStock: '',
      maxInStockDays: '',
      fifo: '',
      icmoPeriodComputeType: '',
      icmoBatchNoComputeType: '',
      precision: '',
      yesornos: [],
      icmoPeriodComputeTypes: [],
      icmoBatchNoComputeTypes: [],
      warningKFPeriod: '',

      showEditCustomNoDialog: false,
      customNo: '',

      showBatchSetDialog: false,
      batchSetFlag: false,
      filterItemNumber: '',

      showSetPower: false,
      showSetCustomNo: false
    }
  },

  computed: {
    codes: function () {
      return this.$store.state.codes
    }
  },

  created: async function () {
    const that = this
    that.menuCode = that.$route.path.substring(1)
    that.menuName = that.$route.meta.title
    const codes = that.codes
    power.setPower(that)
    that.yesornos = code.getCode(codes, 'SYS_YesOrNo')
    that.icmoPeriodComputeTypes = code.getCode(codes, 'WMS_ICMOPeriodComputeType')
    that.icmoBatchNoComputeTypes = code.getCode(codes, 'WMS_ICMOBatchNoComputeType')

    const tableContentPromise = table.refreshTableStructure(that, 'mainTable')
    const tableFilterInfoPromise = tableFilter.refreshTableFliter(that, 'mainTable')

    await tableContentPromise
    await tableFilterInfoPromise
  },

  methods: {
    // 页面主表格深度刷新方法
    deepRefreshMainTableContent: function () {
      const that = this
      that.mainTable.filterStr = that.mainTable.defaultFilterStr
      that.mainTable.orderStr = that.mainTable.defaultOrderStr
      that.refreshMainTableContent()
    },

    // 页面主表格刷新方法
    refreshMainTableContent: function () {
      const that = this
      table.refreshTableContent(that, 'mainTable')
    },

    // 页面主表格换页方法
    mainTablePageChange: function (val) {
      const that = this
      that.mainTable.page = val
      that.refreshMainTableContent()
    },

    // 页面主表格改变每页显示数据条数方法
    mainTableSizeChange: function (val) {
      const that = this
      that.mainTable.page = 1
      that.mainTable.pageSize = val
      that.refreshMainTableContent()
    },

    // 页面主表格排序方式变更方法
    mainTableSortChange: function (column) {
      const that = this
      table.sortChange(column, that, 'mainTable')
    },

    // 页面主表格多选方法
    mainTableSelectionChange: function (selections, row) {
      const that = this
      that.mainTable.selections = selections
    },

    // 页面主表格过滤弹出框显示方法
    mainTableShowFilterDialogMD: function () {
      const that = this
      tableFilter.showTableFliter(that, 'mainTable')
    },

    // 页面主表格过滤方法
    mainTableFilter: function () {
      const that = this
      tableFilter.filter(that, 'mainTable')
    },

    // 页面主表格栏目设置弹框显示方法
    mainTableShowColumnSetDialogMD: function () {
      const that = this
      tableColumnSet.showTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置重置方法
    mainTableUpdateUserColumnSetDialogReset: function () {
      const that = this
      tableColumnSet.resetTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置保存方法
    mainTableSaveUserTableColumn: function () {
      const that = this
      tableColumnSet.saveUserTableColumn(that, 'mainTable')
    },

    // 页面主表格栏目设置恢复默认方法
    mainTableReturnDefaultTableColumn: function () {
      const that = this
      tableColumnSet.returnDefaultTableColumn(that, 'mainTable')
    },

    // 页面主表格过滤设置弹框显示方法
    mainTableShowFilterSetDialogMD: function () {
      const that = this
      tableFilterSet.showTableFliterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置重置方法
    mainTableUpdateUserFilterDialogReset: function () {
      const that = this
      tableFilterSet.resetTableFilterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置保存方法
    mainTableSaveUserTableFilter: function () {
      const that = this
      tableFilterSet.saveUserTableFilter(that, 'mainTable')
    },

    // 页面主表格过滤设置恢复默认方法
    mainTableReturnDefaultTableFilter: function () {
      const that = this
      tableFilterSet.returnDefaultTableFilter(that, 'mainTable')
    },

    // 主表行展开方法
    mainTableExpandRow: function () {
      const that = this
      table.expandRow(that, 'mainTable')
    },

    // 主表行收起方法
    mainTableNarrowRow: function () {
      const that = this
      table.narrowRow(that, 'mainTable')
    },

    // 特征字符串转换方法
    mainTableGetSpecialStringArray: function (columnCode) {
      return []
    },

    // 页面主表格行样式设定方法
    mainTableRowStyle: function (data, rowIndex) {
      if (data.row.Deleted === '1') {
        return { 'background-color': '#cccccc' }
      } else {
        return {}
      }
    },

    // 同步
    synchronization: async function () {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      const preNow = new Date()
      const rtnObj = await axiosHelper.handle('/WebSYSAction/Sync.SyncData', {
        syncCode: 'BD_Item',
        keyValue: ''
      })
      if (rtnObj.error === '000000') {
        const now = new Date()
        that.refreshMainTableContent()
        if (isNaN(rtnObj.msg)) {
          that.$message.success(rtnObj.msg)
        } else {
          that.$message.success('恭喜你，同步成功' + (rtnObj.msg - 1) + '条！' + '共计耗时：' + ((now - preNow) / 1000) + '秒。')
        }
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 设置弹出框显示方法
    showSetDialogMD: function (batchSetFlag) {
      const that = this
      that.batchSetFlag = batchSetFlag
      if (that.mainTable.selections.length <= 0 && !batchSetFlag) {
        that.$message.error('请选择物料！')
        return
      }
      that.showSetDialog = true
      that.canInStock = ''
      that.maxInStockDays = ''
      that.fifo = ''
      that.icmoPeriodComputeType = ''
      that.icmoBatchNoComputeType = ''
      that.precision = ''
      that.warningKFPeriod = ''
      that.filterItemNumber = ''
    },

    // 设置
    setItemSet: async function () {
      const that = this
      if (that.canInStock === '' && that.maxInStockDays === '' &&
        that.fifo === '' && that.icmoPeriodComputeType === '' &&
        that.icmoBatchNoComputeType === '' && that.precision === '' &&
        that.warningKFPeriod === '') {
        that.$message.error('请至少输入一项设置！')
        return
      }
      if (that.maxInStockDays !== '' && that.maxInStockDays !== null) {
        if (!(/(^[0-9]\d*$)/.test(that.maxInStockDays))) {
          that.$message.error('最大生产至入库天数必须为大于等于0的整数！')
          return
        }
      }

      if (that.precision !== '' && that.precision !== null) {
        if (!(/(^[0-9]\d*$)/.test(that.precision))) {
          that.$message.error('领料申请精度必须为大于等于0的整数！')
          return
        }
      }

      if (that.warningKFPeriod !== '' && that.warningKFPeriod !== null) {
        if (!(/(^[0-9]\d*$)/.test(that.warningKFPeriod))) {
          that.$message.error('保质期预警期必须为大于等于0的整数！')
          return
        }
      }

      if (that.batchSetFlag) {
        if (!that.filterItemNumber) {
          that.$message.error('物料代码开头必须输入！')
          return
        }
      }

      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/BaseData.Item.ItemSet', {
        items: that.mainTable.selections,
        canInStock: that.canInStock,
        maxInStockDays: that.maxInStockDays,
        fifo: that.fifo,
        icmoPeriodComputeType: that.icmoPeriodComputeType,
        icmoBatchNoComputeType: that.icmoBatchNoComputeType,
        precision: that.precision,
        warningKFPeriod: that.warningKFPeriod,
        batchSetFlag: that.batchSetFlag,
        filterItemNumber: that.filterItemNumber
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.$message.success('设置成功！')
        that.showSetDialog = false
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 变更客户料号弹出框显示方法
    showEditCustomNoDialogMD: function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请选择物料！')
        return
      }
      if (that.mainTable.selections.length > 1) {
        that.$message.error('请选择单条数据！')
        return
      }
      that.showEditCustomNoDialog = true
      that.customNo = ''
    },

    // 变更客户料号
    editCustomNo: async function () {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/BaseData.Item.ItemCustomNoSet', {
        items: that.mainTable.selections,
        customNo: that.customNo
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.$message.success('变更成功！')
        that.showEditCustomNoDialog = false
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    }
  }
}
</script>

<style scoped>
.navbar {
  padding-bottom: 0px;
  width: 100%;
  padding: 0;
  margin-bottom: 5px;
  margin-top: -10px;
  float: left;
}
.dialogButtomCenterBtn {
  margin-top: 10px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.inputField-label {
  font-size: 14px;
  color: #606266;
  padding-right: 10px;
  vertical-align: middle;
  line-height: 28px;
  float: left;
}
.inputField-input {
  margin-right: 10px;
  float: left;
}
</style>
